import React from 'react';
import { Filter } from 'lucide-react';

interface WorkerFiltersProps {
  filters: {
    status: string;
    gender: string;
  };
  onFilterChange: (filters: { status: string; gender: string }) => void;
}

const WorkerFilters: React.FC<WorkerFiltersProps> = ({ filters, onFilterChange }) => {
  const handleStatusChange = (status: string) => {
    onFilterChange({ ...filters, status });
  };

  const handleGenderChange = (gender: string) => {
    onFilterChange({ ...filters, gender });
  };

  const clearFilters = () => {
    onFilterChange({ status: '', gender: '' });
  };

  const hasActiveFilters = filters.status || filters.gender;

  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2">
        <Filter className="h-4 w-4 text-gray-400" />
        <span className="text-sm font-medium text-gray-700">Filters:</span>
      </div>
      
      {/* Status Filter */}
      <select
        value={filters.status}
        onChange={(e) => handleStatusChange(e.target.value)}
        className="block px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        <option value="on_leave">On Leave</option>
      </select>

      {/* Gender Filter */}
      <select
        value={filters.gender}
        onChange={(e) => handleGenderChange(e.target.value)}
        className="block px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
      >
        <option value="">All Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={clearFilters}
          className="text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default WorkerFilters; 